<template>
    {{ entry.actual_amount > 0 ? Number(entry.actual_amount).toLocaleString() : '' }}
</template>

<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>

</style>
